import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  section: { background: '#f5f5f5', padding: '72px 0 53px' },
  companyDetails: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    width: '100%',
    justifyContent: 'space-around',
    gridGap: '34px',
    '& > div': {
      border: 'solid 1px #000000',
      padding: '22px',
      minHeight: '135px',
      background: '#fff',
    },
    '& > div h3': { marginBottom: '15px' },
    '& > div div': {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      width: '100%',
      marginTop: '8px',
    },
    '& > div div span': { marginRight: '10px' },
  },

  socialContainer: {
    marginTop: '57px',
    '& div': {
      display: 'flex',
      marginBottom: '16px',
      justifyContent: 'space-around',
    },
    '& div a': { display: 'block', width: '7%' },
    '& div a img': {
      display: 'block',
      width: '100%',
      margin: 'auto',
    },
  },
  [theme.breakpoints.up('sm')]: {
    '&': {
      gridGap: '58px',
      '& > div': {
        width: '479px',
        border: 'solid 2px #000000',
        minHeight: '168px',
        padding: '32px 38px',
      },
      '& > div:nth-child(even)': { marginLeft: 'auto' },
    },

    socialContainer: {
      width: '358px',
      margin: '71px auto',
      '& div a': { width: '10%' },
    },
  },
  [theme.breakpoints.up('md')]: {
    section: { marginTop: '202px', paddingBottom: '2rem' },
    companyDetails: {
      marginTop: '-186px',
      gridTemplateColumns: 'auto auto',
      '& > div': {
        width: '305px',
        minHeight: '233px',
        padding: '38px 46px',
        backgroundColor: '#ffffff',
      },
      '& > div h3': {
        textAlign: 'center',
        lineHeight: 1.13,
        marginBottom: '27px',
      },
      // '& > div:nth-child(even)': { marginRight: '0', order: 2 },
      // '& > div:last-child > div': { width: '80%', margin: 'auto' },
    },

    socialContainer: {
      marginTop: '110px',
      '.socialContainer div': {
        justifyContent: 'space-between',
        marginBottom: '50px',
      },
    },
  },
}));
export default style;
